// File: app/src/apis/llm/requestLimits.js
//
// Token limit and sampling fields for the direct OpenAI and Anthropic calls
// (#165). Kept out of providers.js so Jest can import it without the
// ESM-only Gemini SDK.
//
// OpenAI's GPT-5.6 and GPT-6 reason by default. They reject `max_tokens` (the
// field is `max_completion_tokens`) and any `temperature` but the default, and
// their reasoning tokens count against the limit. Anthropic's Haiku 5.5,
// Sonnet 5 and Opus 5 think by default, the thinking counts against
// `max_tokens`, and they (and Opus 4.8) reject a non-default `temperature`.
// So both get thinking headroom and no temperature. DeepSeek, Groq and
// OpenRouter share the OpenAI request shape but not these rules, so they keep
// the classic fields.

import { THINKING_TOKEN_MULTIPLIER, MAX_TOKEN_CEILING } from "./config";

const withThinkingHeadroom = (maxTokens) =>
  Math.min(maxTokens * THINKING_TOKEN_MULTIPLIER, MAX_TOKEN_CEILING);

/**
 * The limit and sampling fields for an OpenAI-shaped chat completions body.
 * @param {string} provider
 * @param {number} maxTokens what the answer itself needs
 * @param {number} [temperature] sent only to providers that accept it
 */
export const openAIRequestLimits = (provider, maxTokens, temperature) => {
  if (provider === "openai") {
    return { max_completion_tokens: withThinkingHeadroom(maxTokens) };
  }
  return {
    ...(temperature === undefined ? {} : { temperature }),
    max_tokens: maxTokens,
  };
};

/**
 * `max_tokens` for an Anthropic-shaped messages body. MiniMax speaks the same
 * format without Claude's default thinking, so it keeps the plain figure.
 */
export const anthropicMaxTokens = (provider, maxTokens) =>
  provider === "anthropic" ? withThinkingHeadroom(maxTokens) : maxTokens;
